import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Popover from "@mui/material/Popover";
import Divider from '@mui/material/Divider';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArgoTextFieldHook from "../../common/ArgoTextFieldHook";
import ArgoTextFieldSelectHook from "../../common/ArgoTextFieldSelectHook";
import ArgoCheckboxHook from "../../common/ArgoCheckboxHook";
import TagSelectOrCreateHook from "../../qd/tags/TagSelectOrCreateHook";
import ArgoButtonHook from "../../common/ArgoButtonHook";
import ArgoIconButtonHook from "../../common/ArgoIconButtonHook";
import { setFilter, clearFilter } from "../../../actions/setFilter";
import { getTagDDLB } from "../../../actions/tagActions";
import { initializeQuestionEditor, clearQuestionTemplateSearchTags } from "../../../actions/questionEditorActions";
import { getIntegrationLogs } from "../../../actions/integrationLogsActions";
import { pageableObjFromFilterSetPageOne, pageableObjFromFilter } from "../../../utilities/PageableAndFilterUtilities";
import { IntegrationTypes } from "../../../constants/integrationConstants";
import { initialPageSortFilterObject } from "../../../constants/filterConstants";
import * as TEMPLATE from "../../../constants/templateConstants";
import * as portalShared from "../../../portal/shared/metadataConstantsAndUtilities";


const KEY_EVENT_TYPE = 'keyup';

let initialFilterClear = Object.assign({}, initialPageSortFilterObject);  // Clone initialFilterObject object.
let initialFilter = Object.assign({}, initialPageSortFilterObject);  // Clone initialFilterObject object.

const FilterPopOverHook = (props) => {
    const [state, setState] = useState({
        open: false,
        tagName: "",
        selectedTags: [],
        typesArray: [], // Used for question types and action types
        ...initialFilter,
        anchorEl: null,
    });

    // Add effect for component mount
    useEffect(() => {
        document.addEventListener(KEY_EVENT_TYPE, onEscapeKey, false);

        if (props.parentName === "QuestionList"){
            props.getTagDDLB(pageableObjFromFilter(props.filterTags), props.filterTags);
            props.initializeQuestionEditor(null, 2);
        }

        // Add All menu item to question types
        let questionTypesObj = {ALL: "All", ...props.types}; //Add All to questions types object
        let typesArray = [];
        Object.keys(questionTypesObj).map(type => typesArray.push({value: type, text: questionTypesObj[type]}));
        setState(prevState => ({
            ...prevState,
            typesArray: typesArray
        }));

        // Cleanup function to remove event listener
        return () => {
            document.removeEventListener(KEY_EVENT_TYPE, onEscapeKey, false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Effect to replicate componentWillReceiveProps
    useEffect(() => {
        // NOTE: Using question depth 2 to store tags for search
        let newState = {
            tagName: "",
            selectedTags: [...props.questionSearchTags],
            ...props.filter
        };

        newState.outstanding = (props.filter !== undefined) ? props.filter.outstanding : false;

        setState(prevState => ({
            ...prevState,
            ...newState
        }));
    }, [props.filter, props.questionSearchTags]);

    const handleIconButtonClick = (event) => {
        // This prevents ghost click.
        event.preventDefault();

        setState(prevState => ({
            ...prevState,
            open: true,
            anchorEl: event.currentTarget,
        }));
    };

    const onChangeText = (event, fieldName) => {
        setState(prevState => ({
            ...prevState,
            [fieldName]: event.target.value
        }));
    };

    const onChangeSelect = (event, fieldName) => {
        setState(prevState => ({
            ...prevState,
            [fieldName]: event.target.value
        }));
    };

    const onChangeCheckbox = (event, fieldName) => {
        setState(prevState => ({
            ...prevState,
            [fieldName]: event.target.checked
        }));
    };

    // const setFilterField = (fieldName, value) => {
    //     let filter = {...props.filter}; // Shallow copy
    //     filter[fieldName] = value;
    // };

    const onClickClearFilter = () => {
        let filter = {...props.filter};

        if (props.page === 'questions') props.clearQuestionTemplateSearchTags(2); // Question Editor Depth 2 is used for FilterPopOverif ((filter.ucid !== "" || filter.questionnaire !== "") && props.integrationID !== null) {
         props.clearFilter(pageableObjFromFilterSetPageOne(props.filter), filter, props.templateType, props.templateMode);
        if (props.page === 'integrationsLogList' && props.integrationID !== null) {
            props.getIntegrationLogs(props.integrationID, filter.name,
                {pageNumber: filter.pageNumber, pageSize: filter.pageSize, name: filter.name, direction: filter.direction},
                filter.ucid, filter.questionnaire);
        }

        setState(prevState => ({
            ...prevState,
            ...initialFilterClear
        }));
    };

    const submitFilter = () => {
        let tags = [];
        for (let i = 0; i < state.selectedTags.length; i++) {
            tags.push(state.selectedTags[i].id);
        }

        let filter = {...props.filter};

        filter.title = state.title;
        filter.nameQualifier = state.nameQualifier;
        filter.updatedBy = state.updatedBy;
        filter.status = state.status;
        filter.questionType = state.questionType;
        filter.integrationType = state.integrationType;
        filter.outstanding = state.outstanding;
        filter.tags = tags;
        filter.questionnaire = state.questionnaire;
        filter.ucid = state.ucid;
        filter.keyMetricIndex = state.keyMetricIndex;
        filter.keyMetric = props.keyMetricArr ? props.keyMetricArr[state.keyMetricIndex] === "All" ? "" : props.keyMetricArr[state.keyMetricIndex] : ""

        if (props.page === 'integrationsLogList' && props.integrationID !== null) {
            props.getIntegrationLogs(props.integrationID, filter.name,
                {pageNumber: filter.pageNumber, pageSize: filter.pageSize, name: filter.name, direction: filter.direction},
                filter.ucid, filter.questionnaire);
        }
        else props.setFilter(pageableObjFromFilterSetPageOne(props.filter), filter, props.templateType, props.templateMode);

        //state does not get set on submit for integrationLogs
        if (typeof props.setLoadingState === "function") {
            props.setLoadingState(closeWindow, null, "FILTER"); // Added filter param for category window for fix filter dows not turn off render animation.
        } else {
            closeWindow();
        }
    };

    const onEscapeKey = (event) => {
        if (event.key === "Escape") {
            closeWindow();
        }
    };

    const closeWindow = () => {
        setState(prevState => ({
            ...prevState,
            open: false
        }));
    };

    if (!props.filter) {
        return null;
    }

    return (
        <div style={{width: "100%", paddingRight: "5px"}}>
            <ArgoIconButtonHook
                fileName="FilterPopOver"
                fieldName="FilterListIcon"
                onClick={handleIconButtonClick}
                icon={<FilterListIcon/>}
            />

            <Popover
                anchorOrigin = {{ vertical: "bottom", horizontal: "right"}}
                open={state.open}
                anchorEl={state.anchorEl}
                slotProps={{style: {height: "455px", width: "700px", backgroundColor: "white"}}}
                onClose={closeWindow}
            >
                <div style={{width: "100%", paddingTop: "5px", paddingLeft: "15px", height: "28px", backgroundColor: portalShared.COLOR_DEFAULT_BLUE_HEX}}>
                    <div style={{color: "white"}}>Filter Options</div>
                </div>

                <div style={{width: "100%", paddingTop: "15px", paddingLeft: "15px", paddingBottom: "15px", paddingRight: "15px"}}>
                    <div style={{height: "100%", width: "320px", float: "left"}}>
                        {props.showName ?
                            <React.Fragment>
                                <ArgoTextFieldHook
                                    fileName="FilterPopOver"
                                    fieldName="title"
                                    label="Name"
                                    value={state.title}
                                    onChange={onChangeText}
                                    autoFocus={true}
                                />

                                <div style={{height: "30px"}}>&nbsp;</div>
                            </React.Fragment>
                            : ""}

                        {props.showUpdatedBy ?
                            <React.Fragment>
                                <ArgoTextFieldHook
                                    fileName="FilterPopOver"
                                    fieldName="updatedBy"
                                    label="Updated by"
                                    value={state.updatedBy}
                                    onChange={onChangeText}
                                />

                                <div style={{height: "30px"}}>&nbsp;</div>
                            </React.Fragment>
                            : ""}

                        {props.showIntegrationTypes ?
                            <React.Fragment>
                                <ArgoTextFieldSelectHook
                                    fileName="FilterPopOver"
                                    fieldName="integrationType"
                                    label="Integration type"
                                    value={state.integrationType}
                                    onChange={onChangeSelect}
                                    menuItems={IntegrationTypes}
                                />

                                <div style={{height: "30px"}}>&nbsp;</div>
                            </React.Fragment>
                            : ""}

                        {props.showQuestionnaire ?
                            <React.Fragment>
                                <ArgoTextFieldHook
                                    fileName="FilterPopOver"
                                    fieldName="questionnaire"
                                    label="Questionnaire"
                                    value={state.questionnaire}
                                    onChange={onChangeText}
                                    autoFocus={true}
                                />

                                <div style={{height: "30px"}}>&nbsp;</div>
                            </React.Fragment>
                            : ""
                        }

                        {props.showUCID ?
                            <React.Fragment>
                                <ArgoTextFieldHook
                                    fileName="FilterPopOver"
                                    fieldName="ucid"
                                    label="UCID"
                                    value={state.ucid}
                                    onChange={onChangeText}
                                />

                                <div style={{height: "30px"}}>&nbsp;</div>
                            </React.Fragment>
                            : ""}

                        {props.showStatus ?
                            <React.Fragment>
                                <ArgoTextFieldSelectHook
                                    fileName="FilterPopOver"
                                    fieldName="status"
                                    label="Status"
                                    value={state.status}
                                    onChange={onChangeSelect}
                                    menuItems={props.statuses}
                                />

                                <div style={{height: "30px"}}>&nbsp;</div>
                            </React.Fragment>
                            : ""}

                        {props.showKeyMetric ?
                            <React.Fragment>
                                <ArgoTextFieldSelectHook
                                    fileName="FilterPopOver"
                                    fieldName="keyMetricIndex"
                                    label="Key Metric"
                                    value={state.keyMetricIndex}
                                    onChange={onChangeSelect}
                                    menuItems={props.keyMetricArr}
                                    dropDownHeight={200}
                                />

                                <div style={{height: "30px"}}>&nbsp;</div>
                            </React.Fragment>
                            : ""}

                        {props.showOutstandingQuestionnaires ?
                            <React.Fragment>
                                <ArgoCheckboxHook
                                    fileName="FilterPopOver"
                                    fieldName="outstanding"
                                    label="Draft with previous versions"
                                    onChange={onChangeCheckbox}
                                    width="300px"
                                    checkBoxPaddingTop="4px"
                                />

                            </React.Fragment>
                            : ""}
                    </div>

                    <div style={{height: "327px", width: "35px", float: "left"}}></div>

                    <div style={{height: "327px", width: "320px", float: "left"}}>
                        <div style={{height: "290px", width: "320px", float: "left"}}>
                            {props.showQualifier ?
                                <React.Fragment>
                                    <ArgoTextFieldHook
                                        fileName="FilterPopOver"
                                        fieldName="nameQualifier"
                                        label="Qualifier"
                                        value={state.nameQualifier}
                                        onChange={onChangeText}
                                    />

                                    <div style={{height: "30px"}}>&nbsp;</div>
                                </React.Fragment>
                                : ""}

                            {props.showQuestionType ?
                                <React.Fragment>
                                    <ArgoTextFieldSelectHook
                                        fileName="FilterPopOver"
                                        fieldName="questionType"
                                        label="Question Type"
                                        value={state.questionType}
                                        onChange={onChangeSelect}
                                        menuItems={state.typesArray}
                                        dropDownHeight={200}
                                    />

                                    <div style={{height: "30px"}}>&nbsp;</div>
                                </React.Fragment>
                                : ""}

                            {/*{props.showActionType ?*/}
                            {/*    <React.Fragment>*/}
                            {/*    <ArgoTextFieldSelectHook*/}
                            {/*        fileName="FilterPopOver"*/}
                            {/*        fieldName="actionType"*/}
                            {/*        label="Action Type"*/}
                            {/*        value={state.actionType}*/}
                            {/*        onChange={onChangeSelect}*/}
                            {/*        menuItems={state.typesArray}*/}
                            {/*    />*/}
                            {/*    </React.Fragment>*/}
                            {/*    : ""}*/}

                            <div>
                                {/*NOTE: I can't explain why question depth has to be 2 here to work*/}
                                {props.showSelectTag ?
                                    <TagSelectOrCreateHook questionDepth={2} allowCreate={false} filterMode={true} selectedTags={props.questionSearchTags}/>
                                    : <div/>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{clear: "both"}}></div>

                {props.parentName === "QuestionnaireList" ? <div>&nbsp;</div> : ""}

                <Divider variant="fullWidth" sx={{ opacity: 1}}/>

                <div id="FilterPopOver-button-container-div" style={{display: "flex", flexDirection: "row", alignItems: "center", width: "100%", paddingLeft: "15px", paddingRight: "15px", paddingTop: "10px", paddingBottom: "10px"}}>
                    <ArgoButtonHook
                        fileName="FilterPopOver"
                        fieldName="close"
                        variant="text"
                        label="Close"
                        width={100}
                        onClick={closeWindow}
                    />

                    <div id={"FilterPopOver-right-buttons-container-div"} style={{display: "flex", marginLeft: "auto"}}>
                        <ArgoButtonHook
                            fileName="FilterPopOver"
                            fieldName="clear"
                            variant="text"
                            label="Clear"
                            width={100}
                            onClick={onClickClearFilter}
                        />

                        <div style={{width: "20px"}}>&nbsp;</div>

                        <ArgoButtonHook
                            fileName="FilterPopOver"
                            fieldName="search"
                            variant="outlined"
                            label="Search"
                            width={100}
                            onClick={submitFilter}
                        />

                        <div style={{width: "40px"}}>&nbsp;</div>
                    </div>
                </div>
            </Popover>
        </div>
    );
};

FilterPopOverHook.defaultProps = {
    showName: true,
    showUpdatedBy: true,
    showStatus: true,
    showQualifier: true,
    showSelectTag: false,
    showQuestionType: false,
    showKeyMetric: false,
    showOutstandingQuestionnaires: false,
    showIntegrationTypes: false,
    showActionType: false,
    showQuestionnaire: false,
    showUCID: false,
    integrationID: null
};

FilterPopOverHook.propTypes = {
    style: PropTypes.object,
    submitValue: PropTypes.func.isRequired,
    page: PropTypes.string,
    templateType: PropTypes.string.isRequired,
    templateMode: PropTypes.string.isRequired,
    filterName: PropTypes.string.isRequired,
    types: PropTypes.object,
    tags: PropTypes.bool,
    outstanding: PropTypes.bool,
    integrationTypes: PropTypes.array,
    setLoadingState: PropTypes.func,
    statuses: PropTypes.array,
    showName: PropTypes.bool,
    showUpdatedBy: PropTypes.bool,
    showStatus: PropTypes.bool,
    showQualifier: PropTypes.bool,
    showSelectTag: PropTypes.bool,
    showQuestionType: PropTypes.bool,
    showKeyMetric: PropTypes.bool,
    keyMetricArr: PropTypes.array,
    showOutstandingQuestionnaires: PropTypes.bool,
    showIntegrationTypes: PropTypes.bool,
    showActionType: PropTypes.bool,
    showQuestionnaire: PropTypes.bool,
    showUCID: PropTypes.bool,
    integrationID: PropTypes.number
};

function mapStateToProps(state, props) {
    return {
        filter: state.filter[props.filterName],
        filterTags: state.filter[TEMPLATE.FILTER.all.selectExistingTags] || {},
        questionSearchTags: (state.questionEditor.length === 3) ? state.questionEditor[2].template.searchTags : [],
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {setFilter,
        clearFilter,
        getTagDDLB,
        initializeQuestionEditor,
        getIntegrationLogs,
        clearQuestionTemplateSearchTags,
        }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterPopOverHook);


